export default __webpack_public_path__ + "static/media/newlogo.bc4caed4.png";